// extracted by mini-css-extract-plugin
export default {"wrapper":"M_SelectPicker_wrapper__zBvRl","background-gray":"M_SelectPicker_background-gray__gKsOu","background-white":"M_SelectPicker_background-white__cuoiL"};